<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('contacto') }}</h2>
			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="name">{{ $t('Nombre') }}</label>
					<input
						type="text"
						v-model="contact.name"
						id="name"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.contact.name.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.name.required"
						>
							{{ $t('name_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.name.maxLength"
						>
							{{ $t('name_validation') }}
						</div>
					</div>
				</div>

				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="position">{{ $t('position') }}</label>
					<input
						type="text"
						v-model="contact.position"
						id="position"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.contact.position.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.position.required"
						>
							{{ $t('position_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.position.maxLength"
						>
							{{ $t('position_validation') }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="email">{{ $t('Email') }}</label>
					<input
						type="text"
						v-model="contact.email"
						id="email"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.contact.email.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.email.required"
						>
							{{ $t('email_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.email.email"
						>
							{{ $t('email_invalido') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.email.maxLength"
						>
							{{ $t('email_validation') }}
						</div>
					</div>
				</div>

				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="phone">{{ $t('Telefono') }}</label>
					<input
						type="number"
						v-model="contact.phone"
						id="phone"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.contact.phone.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.phone.required"
						>
							{{ $t('phone_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.phone.maxLength"
						>
							{{ $t('phone_validation') }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-col md:flex-row">
				<div class="mb-4 md:w-1/2 md:mr-4">
					<label class="block mb-2" for="order">{{ $t('Orden') }}</label>
					<input
						type="number"
						v-model="contact.order"
						id="order"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.contact.order.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.order.required"
						>
							{{ $t('orden_required') }}
						</div>
					</div>
				</div>

				<div class="mb-4 md:w-1/2 md:ml-4">
					<label class="block mb-2" for="categories">{{
						$t('category')
					}}</label>
					<select
						v-model="contact.category_id"
						ref="categories"
						id="categories"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					>
						<option
							v-for="(category, index) in categories"
							:value="category.id"
							:key="index"
						>
							{{ category.category_name }}
						</option>
					</select>
					<div v-if="$v.contact.category_id.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.contact.category_id.required"
						>
							{{ $t('category_required') }}
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="mb-4">
				<img-upload :image="image" />
			</div> -->

			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { single } from '@/mixins'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import ImgUpload from '@/components/ImgUpload.vue'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import { fetchContactsCategoriesSelect } from '@/apollo/contactsCategories'
import { fetchContact, insertContact, updateContact } from '@/apollo/contacts'

export default {
	mixins: [single],
	components: {
		PulseLoader
		// ImgUpload
	},
	data() {
		return {
			contact: {
				name: '',
				position: '',
				email: '',
				phone: '',
				order: '',
				category_id: '',
				image_id: ''
			},
			categories: []
			// image: {
			// 	image_64: null,
			// 	temp: null,
			// 	file_name: null,
			// 	file_mime: null
			// }
		}
	},
	apollo: {
		categories: fetchContactsCategoriesSelect(),
		contact() {
			const query = fetchContact(this.id)
			query.skip = this.id == null
			return query
		}
	},
	methods: {
		updateContact() {
			const mutationData = {
				contactId: this.id,
				contactData: this.getContactProps(),
				contactOrganizations: []
			}
			return this.$apollo.mutate(updateContact(mutationData))
		},
		insertNewContact() {
			const mutationData = {
				contactData: this.getContactProps(),
				contactOrganizations: []
			}
			return this.$apollo.mutate(insertContact(mutationData))
		},
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.id != null ? this.updateContact() : this.insertNewContact())
					.then(() => {
						this.stopLoadingState()
						this.id ? this.$alert("Tu contacto está actualizado", "¡Enhorabuena!", "success") : this.$alert("Su contacto ha sido creado", "¡Enhorabuena!", "success")
					})
					.catch(error => {
						this.setError(error)
						this.stopLoadingState()
						this.$alert(error, "Error", "error")

					})
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), "Advertencia", "warning")
			}
		},
		getContactProps() {
			const result = {
				email: this.contact.email,
				name: this.contact.name,
				order: this.contact.order,
				phone: `${this.contact.phone}`,
				position: this.contact.position,
				category_id: this.contact.category_id
			}
			return result
		},
		startLoadingState() {
			this.server_error = ''
			this.buton_text = this.$t('sending')
			this.loading = true
			this.$store.dispatch('isLoading', true)
		},
		stopLoadingState() {
			this.loading = false
			this.$store.dispatch('isLoading', false)
			this.buton_text = this.$t('sended')
			this.error = false
			this.base = ''
		}
	},
	validations() {
		return {
			contact: {
				category_id: {
					required
				},
				name: {
					required,
					maxLength: maxLength(100)
				},
				position: {
					required,
					maxLength: maxLength(50)
				},
				email: {
					required,
					email,
					maxLength: maxLength(100)
				},
				phone: {
					required,
					maxLength: maxLength(50)
				},
				order: {
					required
				}
			}
		}
	}
}
</script>
